/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
    // Query the element
    const printBtn = document.getElementById('print_btn');
  
    printBtn.addEventListener('click', function () {
        // Create a fake iframe
        const iframe = document.createElement('iframe');
  
        // Make it hidden
        iframe.style.height = 0;
        iframe.style.visibility = 'hidden';
        iframe.style.width = 0;
  
        // Set the iframe's source
        iframe.setAttribute('srcdoc', '<html><body></body></html>');
  
        document.body.appendChild(iframe);
  
        iframe.contentWindow.addEventListener('afterprint', function () {
            iframe.parentNode.removeChild(iframe);
        });
  
        iframe.addEventListener('load', function () {
            // Clone the image
            const image = document.querySelector('#printableArea img').cloneNode();
            image.style.maxWidth = '100%';
  
            // Append the image to the iframe's body
            const body = iframe.contentDocument.body;
            body.style.textAlign = 'center';
            body.appendChild(image);
  
            image.addEventListener('load', function () {
                // Invoke the print when the image is ready
                iframe.contentWindow.print();
            });
        });
    });
  });


// -----------  js Added for complete the look section in product page start here 

 $('.product-info .HorizontalList__Item input[type=radio]').change(function(){
            
        let demoats = [];
        let myVar2 = [];      
    
        var dere = $(this).parents('.product-info').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();
       
        demoats.push(srp_var);        
        myVar2 = demoats.join(' / ');        
        })
       var prets = $(this).parents('.product-info').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                               
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');               
              $(this).attr('selected', true).siblings().attr('selected', false); 
               var on_select_price = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-price');
               $(this).parents('.product-info').find('.price_tag').html(on_select_price);
              var on_select_quantity = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-quantity');              
              if(on_select_quantity <= 0)
              {
                $(this).parents('.product-info').find('.add_to_cart_btn').attr('disabled', 'disabled');
                $(this).parents('.product-info').find('.add_to_cart_btn').removeClass('Button--primary');
                $(this).parents('.product-info').find('.add_to_cart_btn').addClass('Button--secondary');
                $(this).parents('.product-info').find('.add_to_cart_btn').text('SOLD OUT');                
              }
              else{
                 $(this).parents('.product-info').find('.add_to_cart_btn').removeAttr('disabled', 'disabled');
                $(this).parents('.product-info').find('.add_to_cart_btn').addClass('Button--primary');
                $(this).parents('.product-info').find('.add_to_cart_btn').removeClass('Button--secondary');
                $(this).parents('.product-info').find('.add_to_cart_btn').text('ADD TO CART');      
              }
              var on_select_var_img = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-variant-image');
              $(this).parents('.product-info').find('.img-info img').attr('src',on_select_var_img);
                               
            }        
        }) 
     
      })
      let data = '';
  $(document).on('click','.product-info .add_to_cart_btn',function(){  
    
   var btn_this = this;    
        let demoats = [];
        let myVar2 = [];          
        var dere = $(this).parents('.product-info').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();       
        demoats.push(srp_var);       
        myVar2 = demoats.join(' / ');             
        })
        var prets = $(this).parents('.product-info').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                                   
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');             
              $(this).attr('selected', true).siblings().attr('selected', false);                                                      
            }        
        })  
    
var ID = $(this).parents('.product-info').find('.product-variant-selector').find(":selected").val();  
let properties = $('#giftNote').val();
console.log(typeof properties)
if(properties != ''){
  data = {
    quantity: 1,
    id: ID,
    properties: { 'Gift Note' : properties }
  }
}else{
  data = {
    quantity: 1,
    id: ID,
  }
}

$.ajax({
type: 'POST',
url: '/cart/add.js',
data: data,
  dataType: 'json', 
 success: function (data) {    
     $(this).removeAttr('disabled');    
   document.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
           detail: {
                variant: null,
                quantity: 1
              }
            }));
            // $('.ProductForm input[name="properties[Gift Note]"]').remove();
            $('#giftNote').val('');
 },
      error: function (error) { 
         var error_html = '<div class="error_msg"></div>'
         $( ".add_to_cart_btn" ).after(error_html); 
         var error_msg_show = error.responseJSON.description;     
         $(btn_this).parents('.product-info').find('.error_msg').html(error_msg_show);                
         setTimeout(function () {
                $(".error_msg").remove();
         }, 2500);
      }
 });
})


// -----------  js Added for complete the look section in product page end here 

//**********************************

// -----------  js Added for Related product in product page start here 


 $('.rp-pro-block .HorizontalList__Item input[type=radio]').change(function(){
            
        let demoats = [];
        let myVar2 = [];      
    
        var dere = $(this).parents('.rp-pro-block').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();
       
        demoats.push(srp_var);        
        myVar2 = demoats.join(' / ');        
        })
       var prets = $(this).parents('.rp-pro-block').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                               
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');               
              $(this).attr('selected', true).siblings().attr('selected', false); 
               var on_select_price = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-price');
               $(this).parents('.rp-pro-block').find('.ProductItem__Price.Price--highlight').html(on_select_price);
               var on_select_compare_price = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-compare-price');
               $(this).parents('.rp-pro-block').find('.ProductItem__Price.Price--compareAt').html(on_select_compare_price);
              var on_select_quantity = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-quantity');              
              if(on_select_quantity <= 0)
              {
                $(this).parents('.rp-pro-block').find('.add_to_cart_btn').attr('disabled', 'disabled');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').removeClass('Button--primary');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').addClass('Button--secondary');
                $(this).parents('.rp-pro-block').find('.add_to_cart_btn').text('SOLD OUT');                
              }
              else{
                 $(this).parents('.rp-pro-block').find('.add_to_cart_btn').removeAttr('disabled', 'disabled');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').addClass('Button--primary');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').removeClass('Button--secondary');
                $(this).parents('.rp-pro-block').find('.add_to_cart_btn').text('ADD TO CART');      
              }
              var on_select_var_img = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-variant-image');              
              $(this).parents('.rp-pro-block').find('img.related_pro_first_img').attr('srcset',on_select_var_img);
                               
            }        
        }) 
     
      })

  $(document).on('click','.rp-pro-block .add_to_cart_btn',function(){      
   var btn_this = this;    
        let demoats = [];
        let myVar2 = [];          
        var dere = $(this).parents('.rp-pro-block').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();       
        demoats.push(srp_var);       
        myVar2 = demoats.join(' / ');             
        })  
        var prets = $(this).parents('.rp-pro-block').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                                   
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');             
              $(this).attr('selected', true).siblings().attr('selected', false);                                                      
            }        
        })  
    
var ID = $(this).parents('.rp-pro-block').find('.product-variant-selector').find(":selected").val(); 
    // console.log(ID);
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
},
  dataType: 'json', 
 success: function (data) {    
     $(this).removeAttr('disabled');    
   document.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
           detail: {
                variant: null,
                quantity: 1
              }
            }));
 },
      error: function (error) { 
         var error_html = '<div class="error_msg"></div>'
        // var add_btn = $(btn_this).parents('.rp-pro-block').find( ".add_to_cart_btn" );
         // $(add_btn).after(error_html); 

        $(btn_this).after(error_html); 
         var error_msg_show = error.responseJSON.description;     
         $(btn_this).parents('.rp-pro-block').find('.error_msg').html(error_msg_show);                
         setTimeout(function () {
                $(".error_msg").remove();
         }, 2500);
      }
 });
})

$(".related-pro-scroll").click(function() {
    $('html, body').animate({
        scrollTop: $("#related-product-section-scroll").offset().top-70
    }, 800); 
});
// -----------  js Added for Related product in product page end here 

$(document).ready(function(){
  $(document).on('change','.ColorSwatch__Radio,.SizeSwatch__Radio',function(){
    // $('.ProductForm input[name="properties[Gift Note]"]').remove();
        $('#giftNote').val('');
  })
})